import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SurveyLanguageDropdown from '../dropdowns/SurveyLanguageDropdown';
import CountdownTimer from './CountdownTimer';
import { getAllQuestionAndAnswer, getDataByLanguage, startSurvey, submitSurvey, getSurveySections } from "./service";
import SingleAnswerType from '../answerTypes/singleAnswerType';
import MultipleAnswerType from '../answerTypes/multipleAnswerType';
import NumberScaleAnswerType from '../answerTypes/numberscaleAnswerType';
import SubjectiveAnserType from '../answerTypes/subjectiveAnserType';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NumberScaleComponent from '../answerTypes/numberscaleAnswerType';
import SurveyExpired from './surveyExpired';
import SubjectiveAnswerType from '../answerTypes/subjectiveAnserType';
import CompoundAnswerWithReason from '../answerTypes/compoundAnswerWithReason';
import Logo from '../assets/dolphinLogo.png'
import AshonLogo from '../assets/Ashon_white_logo.png';
import HopeVentures from '../assets/img/HopeVenturesWhite.png';
import workplusHcm from '../assets/img/workplusHcm.png';
import workplusLogo from '../assets/img/logo2.png';
import HeaderCountdownTimer from './headerCountDown';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import required styles
import { getCompanyId } from '../utility';

export default class ParticipantAttendees extends Component {
    constructor(props) {
        super(props);
        this.answerTypeRef = React.createRef();
        this.state = {
            participantAttendees: this.props.participantAttendees || {
                endDate: '',
                endTime: '',
                participantName: '',
                startDate: '',
                startTime: '',
                status: '',
                surveyEndReminder: '',
                surveyName: '',
                surveyStartReminder: '',
                surveyId: 0,
                startDateTime: '',
                endDateTime: '',
                description: '',
                participantId: 0,
                submissionStartDateTime: null,
                submittedOn: null,
                isSubmitted: '',
                languageId: '',
                isRandomized: '',
                companyId: 0,
                logoBase64: null,
                logoMimeType: null,
                logoSource: null
            },
            languageId: '1',
            editable: false,
            shouldRender: false,
            data: [],
            attendeesEntity: {},
            convertedDescription: '',
            surveyStarted: false,
            order: [],
            loading: false,
            isDataLoaded : false,
            sections: [],
            pageSortEnabled: false,
            currentPage: 1,
            descriptionCollapsed: false,
        }

    }

    fetchSections = () => {
        const { surveyId, companyId } = this.state.participantAttendees;
        if (!surveyId) return;
        getSurveySections(surveyId, companyId)
            .then(res => {
                if (res && res.status === 'OK' && res.data && res.data.length > 0) {
                    const pageSortEnabled = res.data.some(s => s.pageNumber != null && s.pageNumber > 0);
                    this.setState({ sections: res.data, pageSortEnabled, currentPage: 1 });
                }
            })
            .catch(() => {});
    }

    componentDidMount() {
        const currentDate = new Date();
        const futureDate = new Date(this.state.participantAttendees.startDateTime);
        this.convertHTMLToText(this.state.participantAttendees.description);
        this.fetchSections();
        if (currentDate >= futureDate) {
            this.setState({ shouldRender: true, languageId: 1 });
            if (this.state.participantAttendees.submissionStartDateTime !== null) {
                let currentLanguage = this.state.participantAttendees.languageId;
                this.setState({
                    languageId: currentLanguage,
                    editable: true,
                    descriptionCollapsed: true,
                }, () => {
                    this.fetchList(this.state.languageId);
                    this.handleLanguageChange(this.state.languageId);
                })

            }
        } else {
            this.interval = setInterval(() => {
                const updatedCurrentDate = new Date();
                if (updatedCurrentDate >= futureDate) {
                    this.setState({ shouldRender: true });
                    clearInterval(this.interval);
                }
            }, 60000);
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    handleLanguageChange = (e) => {
        let languageId;
        if (typeof e === 'object') {
            if (e.target.value === 'Select Language') {
                languageId = 1;
            } else {
                languageId = e.target.value;
            }
        } else {
            languageId = e;
        }
        const { surveyId } = this.state.participantAttendees;

        getDataByLanguage(languageId, surveyId)
            .then(res => {
                const updatedParticipantAttendees = { ...this.state.participantAttendees };

                if (res.data) {
                    updatedParticipantAttendees.surveyName = res.data.name;
                    updatedParticipantAttendees.description = res.data.description;
                    updatedParticipantAttendees.submissionStartDateTime = this.state.participantAttendees.submissionStartDateTime;
                }
                this.setState({
                    languageId,
                    participantAttendees: updatedParticipantAttendees
                }, () => {
                    if (languageId === '1' || languageId === 'Select Language') {
                        this.fetchList(1);
                    } else {
                        this.fetchList(languageId);
                    }
                    this.convertHTMLToText(updatedParticipantAttendees.description);
                });
            })
            .catch(error => {
                console.log(error);
            });
    }



    fetchList = async (languageId) => {
        try {
            getAllQuestionAndAnswer(
                this.props.participantAttendees.surveyId,
                languageId,
                this.state.participantAttendees.participantId
            )
                .then((res) => {
                    if (res.status === 'OK') {
                        var dbData = null;
                        const { order } = this.state;

                        var dbOrder = order;

                        if (this.state.participantAttendees.isRandomized === true) {
                            if (order.length > 0) {
                                dbData.sort((a, b) => {
                                    const indexA = order.findIndex(item => item.id === a.id);
                                    const indexB = order.findIndex(item => item.id === b.id);
                                    return indexA - indexB;
                                });
                            } else {
                                dbData = this.shuffleArray(res.data.surveyQuestionAnswer);

                                dbData.forEach((element, index) => {
                                    dbOrder.push({
                                        id: element.surveyQuestionResponse.id
                                    })
                                });

                            }
                            res.data.surveyQuestionAnswer = dbData;


                        } else {
                            dbData = res.data.surveyQuestionAnswer.sort((a, b) => a.surveyQuestionResponse.sortOrder - b.surveyQuestionResponse.sortOrder);
                            res.data.surveyQuestionAnswer = dbData;
                        }

                       

                        this.setState({
                            data: res.data,
                            order: dbOrder,
                            loading: true,
                            isDataLoaded: true
                        });
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        } catch (error) {
            console.error(error);
        }
    };

    shuffleArray(array) {
        const shuffledArray = [...array];
        for (let i = shuffledArray.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            [shuffledArray[i], shuffledArray[randomIndex]] = [shuffledArray[randomIndex], shuffledArray[i]];
        }
        return shuffledArray;
    }

    convertHTMLToText(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const text = this.parseNode(doc.documentElement);
        this.setState({ convertedDescription: text });
    }

    parseNode(node) {
        let result = '';

        for (let i = 0; i < node.childNodes.length; i++) {
            const child = node.childNodes[i];

            if (child.nodeType === Node.TEXT_NODE) {
                result += child.textContent;
            } else if (child.nodeType === Node.ELEMENT_NODE) {
                if (child.nodeName === 'STRONG' || child.nodeName === 'B') {
                    result += '<strong>' + this.parseNode(child) + '</strong>';
                } else if (child.nodeName === 'EM' || child.nodeName === 'I') {
                    result += '<em>' + this.parseNode(child) + '</em>';
                } else if (child.nodeName === 'SPAN' && child.style.color) {
                    const color = child.style.color;
                    result += '<span style="color:' + color + '">' + this.parseNode(child) + '</span>';
                } else {
                    result += this.parseNode(child);
                }
            }
        }

        return result;
    }





    onSurveyStart = () => {
        const { participantAttendees, languageId } = this.state;

        startSurvey(participantAttendees.surveyId, languageId, participantAttendees.participantId)
            .then(res => {
                if (res.status === 'OK') {
                    this.setState({
                        attendeesEntity: res.data,
                        surveyStarted: true,
                    }, () => {
                        if (languageId === '1' || languageId === 'Select Language') {
                            this.fetchList(1);
                            this.handleLanguageChange(1);
                        } else {
                            this.fetchList(languageId);
                            this.handleLanguageChange(languageId)
                        }
                        window.location.reload();
                    });
                } else {
                    console.error("Invalid response received from start Survey");
                }
            })
            .catch(error => {
                console.error(error);
            });
    };
    submit = async () => {
        this.setState({ isDataLoaded: false }, async () => {  
            await this.fetchList(this.state.participantAttendees.languageId);
    
            const waitForDataLoad = async () => {
                while (!this.state.isDataLoaded) {
                    await new Promise(resolve => setTimeout(resolve, 100)); // Wait for 100ms before checking again
                }
            };
            await waitForDataLoad();
            if (this.answerTypeRef.current) {
                await this.answerTypeRef.current.triggerBlur();
            }
                confirmAlert({
                    title: `Submit Survey`,
                    message: 'Are you sure, you want to Submit Survey?',
                    buttons: [
                        {
                            label: 'Yes',
                            onClick: () => this.onSubmitSurvey(),
                        },
                        {
                            label: 'No',
                            onClick: () => { }
                        }
                    ]
                });
        });
    };
    onSubmitSurvey = () => {
        const { participantAttendees, languageId, data } = this.state;

        for (let i = 0; i < data.surveyQuestionAnswer.length; i++) {
            if (data.surveyQuestionAnswer[i].surveyQuestionResponse.isMandatory === true) {
                const answer = data.surveyQuestionAnswer[i].surveyResponseAnswers.answers;
                // if (answer === null || answer.trim() === '' || answer === "[]") {
                if (answer === null || answer.trim() === '' || (Array.isArray(answer) && answer.length === 0) || answer === "[]") {
                    toast.error("Please Answer All Mandatory Questions");
                    return;
                }
            } else {
                continue;
            }
        }

        submitSurvey(participantAttendees.surveyId, languageId, participantAttendees.participantId)
            .then(res => {
                if (res.status === 'OK') {
                    let message = res.data;
                    this.props.history.push('/survey/submitted', { message: message });
                } else {
                    console.error("Invalid response received from startSurvey");
                }
            })
            .catch(error => {
                console.error(error);
            });
    }
    onSaveAsDraft = () => {
        toast.success("Survey Saved As Draft");
    };

    goToNextPage = (sortedPageNumbers) => {
        const { currentPage } = this.state;
        const idx = sortedPageNumbers.indexOf(currentPage);
        if (idx < sortedPageNumbers.length - 1) {
            this.setState({ currentPage: sortedPageNumbers[idx + 1] });
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    goToPrevPage = (sortedPageNumbers) => {
        const { currentPage } = this.state;
        const idx = sortedPageNumbers.indexOf(currentPage);
        if (idx > 0) {
            this.setState({ currentPage: sortedPageNumbers[idx - 1] });
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-US', options);

        // Removing the comma from the formatted date
        const formattedDateWithoutComma = formattedDate.replace(',', '');

        // Adding a space before the month
        const [month, day, year] = formattedDateWithoutComma.split(' ');
        return `${day}  ${month} ${year}`;
    };

    formatTime = (dateTime) => {
        const date = new Date(dateTime);
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        let period = 'AM';

        let parsedHours = hours;

        if (hours >= 12) {
            period = 'PM';
            if (hours > 12) {
                parsedHours = hours - 12;
            }
        }

        if (parsedHours === 0) {
            parsedHours = 12;
        }

        return `${parsedHours}:${minutes} ${period}`;
    };

    formatDescription = (description) => {
        if (!description) {
            return ""; // Return an empty string if description is undefined or null
        }
        // Step 1: Remove <span> and <o:p> tags
        let cleanedDescription = description.replace(/<\/?span[^>]*>/g, "").replace(/<\/?o:p>/g, "");
    
        // Step 2: Replace closing `</p>` tags with `<br>` followed by a newline for separation
        cleanedDescription = cleanedDescription
            .replace(/<p[^>]*>/g, "")   // Remove all opening <p> tags
            .replace(/<\/p>/g, "<br>"); // Replace all closing </p> tags with <br>
    
        return cleanedDescription.trim();
    };

    resolveLogoSrc = () => {
        const { logoBase64, logoMimeType } = this.state.participantAttendees;
        if (logoBase64 && logoBase64.length > 0) {
            return `data:${logoMimeType || 'image/png'};base64,${logoBase64}`;
        }
        return getCompanyId() == 34 ? HopeVentures : getCompanyId() == 43 ? HopeVentures : workplusLogo;
    };

    render() {
        const { participantAttendees, languageId, editable, shouldRender, data, convertedDescription, surveyStarted, sections, pageSortEnabled, currentPage, descriptionCollapsed } = this.state;

        const _sortedPageNumbers = pageSortEnabled && sections.length > 0
            ? [...new Set(sections.map(s => s.pageNumber || 1))].sort((a, b) => a - b)
            : [];
        const _currentPageIdx = _sortedPageNumbers.indexOf(currentPage);
        const _isLastPage = _sortedPageNumbers.length === 0 || currentPage === _sortedPageNumbers[_sortedPageNumbers.length - 1];

        const targetStartDate = new Date(participantAttendees.startDateTime);
        const targetEndDate = new Date(participantAttendees.endDateTime);
        const now = new Date().getTime();
        const surveyExpired = targetEndDate.getTime() - now >= 0;

        return (
            <div className="">
                <Helmet>
                    <title> Survey Page </title>
                </Helmet>
                {surveyExpired &&
                    <div className="content">
                        <div className="">
                            <div className="survey-header">
                                <div className="logo">
                                    <a style={{ cursor: 'revert' }} >
                                        <img className="logoImgSurvey" src={this.resolveLogoSrc()} alt="WorkPlus" width={"110px"} height={"40px"}
                                            onError={(e) => { e.target.onerror = null; e.target.src = workplusLogo; }} />
                                    </a>
                                </div>
                                <div className="survey-title-container">
                                    <p className="survey-title">{participantAttendees.surveyName}</p>
                                </div>
                                <div className="timer">{shouldRender &&
                                    <div className="float-right col-auto ml-auto">
                                        <HeaderCountdownTimer targetDate={targetEndDate} />
                                    </div>}</div>
                            </div>
                            

                            <div className="">
                                <div className='row '>
                                    <div className='col-md-12' >

                                        {shouldRender ? <>
                                            {descriptionCollapsed ? (
                                                <div className="desc-collapsed-bar" onClick={() => this.setState({ descriptionCollapsed: false })}>
                                                    <span style={{ fontWeight: 500, fontSize: '14px' }}>{participantAttendees.surveyName}</span>
                                                    <span className="desc-toggle-arrow">&#9660; Show Description</span>
                                                </div>
                                            ) : (
                                            <div style={{ background: '#e3e3e3', padding: '17px', position: 'sticky', top: '46px', zIndex: 199 }}>
                                                <div className="survey-title-mobile">
                                                    <h3 style={{ color: '#102746' }} className="m-0 survey-title">{participantAttendees.surveyName}</h3>
                                                </div>
                                                {participantAttendees.submissionStartDateTime !== null && (
                                                    <div className="desc-collapse-btn" onClick={() => this.setState({ descriptionCollapsed: true })}>
                                                        &#9650; Hide Description
                                                    </div>
                                                )}
                                                <p className="survey_description">
                                                    <div className='desc-box' dangerouslySetInnerHTML={{ __html: this.formatDescription(participantAttendees.description) }}></div>
                                                </p>
                                                <div className='d-flex' style={{ justifyContent: 'space-between', alignItems: 'flex-end' }}>
                                                    <div className='d-flex'>
                                                        <div className='col-md-auto'>
                                                            <label>Select Language <span style={{ color: '#102746' }} className="required">*</span></label>
                                                            <SurveyLanguageDropdown
                                                                surveyId={participantAttendees.surveyId}
                                                                readOnly={editable}
                                                                defaultValue={languageId}
                                                                onChange={this.handleLanguageChange}
                                                            />
                                                        </div>
                                                        <div style={{ placeContent: 'center', marginTop: '30px' }}>
                                                            {participantAttendees.submissionStartDateTime === null && !surveyStarted && shouldRender && (
                                                                <button style={{ background: '#102746' }} className="btn btn-secondary" onClick={this.onSurveyStart}>
                                                                    Start
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {pageSortEnabled && _sortedPageNumbers.length > 0 && (
                                                        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                                            <button
                                                                type="button"
                                                                disabled={_currentPageIdx === 0}
                                                                onClick={() => this.goToPrevPage(_sortedPageNumbers)}
                                                                style={{
                                                                    background: '#fff',
                                                                    border: '1.5px solid ' + (_currentPageIdx === 0 ? '#e3e8f0' : '#c2cfe0'),
                                                                    borderRadius: '50%', width: '32px', height: '32px',
                                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                    color: _currentPageIdx === 0 ? '#c2cfe0' : '#102746',
                                                                    fontSize: '18px', fontWeight: 700,
                                                                    boxShadow: '0 1px 4px rgba(16,39,70,0.08)',
                                                                    cursor: _currentPageIdx === 0 ? 'not-allowed' : 'pointer',
                                                                }}
                                                            >
                                                                &#8249;
                                                            </button>
                                                            <span style={{
                                                                background: '#102746', color: '#fff',
                                                                borderRadius: '20px', padding: '4px 16px',
                                                                fontSize: '13px', fontWeight: 700, whiteSpace: 'nowrap',
                                                                boxShadow: '0 1px 4px rgba(16,39,70,0.15)',
                                                            }}>
                                                                {_currentPageIdx + 1}
                                                            </span>
                                                            <button
                                                                type="button"
                                                                disabled={_isLastPage}
                                                                onClick={() => this.goToNextPage(_sortedPageNumbers)}
                                                                style={{
                                                                    background: '#fff',
                                                                    border: '1.5px solid ' + (_isLastPage ? '#e3e8f0' : '#c2cfe0'),
                                                                    borderRadius: '50%', width: '32px', height: '32px',
                                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                    color: _isLastPage ? '#c2cfe0' : '#102746',
                                                                    fontSize: '18px', fontWeight: 700,
                                                                    boxShadow: '0 1px 4px rgba(16,39,70,0.08)',
                                                                    cursor: _isLastPage ? 'not-allowed' : 'pointer',
                                                                }}
                                                            >
                                                                &#8250;
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>

                                            </div>
                                            )}

                                            <div className="newSurvey-body">
                                                <div className="mandatorySymbol">
                                                    <span style={{ color: '#102746' }}>*</span>
                                                    <span> Mandatory Questions</span>
                                                </div>
                                                {data && participantAttendees.submissionStartDateTime !== null && data.surveyQuestionAnswer && data.surveyQuestionAnswer.length > 0 ? (
                                                    <div className='mt-2'>
                                                        {(() => {
                                                            const firstSectionId = sections.length > 0 ? sections[0].id : 'default';

                                                            // Build section groups
                                                            const sectionOrder = [];
                                                            const sectionGroups = {};
                                                            data.surveyQuestionAnswer.forEach(item => {
                                                                const sId = item.surveyQuestionResponse.sectionId || firstSectionId;
                                                                if (!sectionGroups[sId]) {
                                                                    sectionGroups[sId] = [];
                                                                    sectionOrder.push(sId);
                                                                }
                                                                sectionGroups[sId].push(item);
                                                            });
                                                            sectionOrder.forEach(sId => {
                                                                sectionGroups[sId].sort((a, b) => a.surveyQuestionResponse.sortOrder - b.surveyQuestionResponse.sortOrder);
                                                            });

                                                            // Determine which section IDs to show
                                                            let visibleSectionIds = sectionOrder;
                                                            let sortedPageNumbers = [];
                                                            let isLastPage = true;

                                                            if (pageSortEnabled && sections.length > 0) {
                                                                sortedPageNumbers = [...new Set(sections.map(s => s.pageNumber || 1))].sort((a, b) => a - b);
                                                                const activePage = sortedPageNumbers.includes(currentPage) ? currentPage : sortedPageNumbers[0];
                                                                isLastPage = activePage === sortedPageNumbers[sortedPageNumbers.length - 1];
                                                                const sectionsOnPage = sections.filter(s => (s.pageNumber || 1) === activePage).map(s => s.id);
                                                                visibleSectionIds = sectionOrder.filter(sId => sectionsOnPage.includes(sId));
                                                            }

                                                            const renderedSections = visibleSectionIds.map((sId, sIdx) => {
                                                                const sectionInfo = sections.find(s => s.id === sId) || { name: `SECTION ${sIdx + 1}` };
                                                                const questions = sectionGroups[sId];
                                                                return (
                                                                    <div key={sId} style={{ border: '1px solid #c2cfe0', borderRadius: '8px', marginBottom: '24px', overflow: 'hidden' }}>
                                                                        <div style={{ background: '#102746', color: '#fff', padding: '10px 16px', borderLeft: '4px solid #4f6ef7' }}>
                                                                            <strong style={{ fontSize: '14px', letterSpacing: '0.4px' }}>{sectionInfo.name}</strong>
                                                                            <span style={{ fontSize: '12px', marginLeft: '8px', opacity: 0.75 }}>({questions.length} Questions)</span>
                                                                        </div>
                                                                        <div style={{ padding: '12px 16px' }}>
                                                                            {questions.map((item, qIdx) => (
                                                                                <div style={{ fontSize: '14px', fontWeight: 600, color: '#102746' }} className='' key={`${qIdx}-${item.surveyQuestionResponse.id}`}>
                                                                                    <br />
                                                                                    <div className='mt-2 d-flex'>
                                                                                        <label className='mr-1'>{qIdx + 1}.  </label>
                                                                                        <label className=''>
                                                                                            {item.surveyQuestionResponse.isMandatory ? (
                                                                                                <span style={{ color: '#102746' }}>{item.surveyQuestionResponse.question}<span style={{ color: '#102746' }}>*</span></span>
                                                                                            ) : (
                                                                                                <span style={{ color: '#102746' }}>{item.surveyQuestionResponse.question}</span>
                                                                                            )}
                                                                                        </label>
                                                                                    </div>
                                                                                    {item.surveyQuestionResponse.answerType === 'SINGLE_ANSWER' ? (
                                                                                        <SingleAnswerType answers={item.surveyQuestionResponse.answers} participantAttendees={this.state.participantAttendees} surveyQuestionResponse={item.surveyQuestionResponse} surveyResponseAnswers={item.surveyResponseAnswers} fetchList={this.fetchList} />
                                                                                    ) : item.surveyQuestionResponse.answerType === 'MULTIPLE_ANSWER' ? (
                                                                                        <MultipleAnswerType answers={item.surveyQuestionResponse.answers} participantAttendees={this.state.participantAttendees} surveyQuestionResponse={item.surveyQuestionResponse} surveyResponseAnswers={item.surveyResponseAnswers} fetchList={this.fetchList} />
                                                                                    ) : item.surveyQuestionResponse.answerType === 'NUMBER_SCALE' ? (
                                                                                        <NumberScaleComponent answers={item.surveyQuestionResponse.answers} participantAttendees={this.state.participantAttendees} surveyQuestionResponse={item.surveyQuestionResponse} surveyResponseAnswers={item.surveyResponseAnswers} fetchList={this.fetchList} />
                                                                                    ) : item.surveyQuestionResponse.answerType === 'SUBJECTIVE' ? (
                                                                                        <SubjectiveAnswerType ref={this.answerTypeRef} answers={item.surveyQuestionResponse.answers} participantAttendees={this.state.participantAttendees} surveyQuestionResponse={item.surveyQuestionResponse} surveyResponseAnswers={item.surveyResponseAnswers} fetchList={this.fetchList} />
                                                                                    ) : item.surveyQuestionResponse.answerType === 'COMPOUND_ANSWER_WITH_REASON' ? (
                                                                                        <CompoundAnswerWithReason answers={item.surveyQuestionResponse.answers} participantAttendees={this.state.participantAttendees} surveyQuestionResponse={item.surveyQuestionResponse} surveyResponseAnswers={item.surveyResponseAnswers} fetchList={this.fetchList} />
                                                                                    ) : (
                                                                                        item.surveyQuestionResponse.answers.map((answer) => (
                                                                                            <div key={answer.id}>{answer.answer}</div>
                                                                                        ))
                                                                                    )}
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            });

                                                            const currentPageIdx = sortedPageNumbers.indexOf(currentPage);

                                                            const bottomBar = pageSortEnabled ? (
                                                                <div style={{
                                                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                                    background: '#f4f6fb', border: '1px solid #e3e8f0',
                                                                    borderRadius: '10px', padding: '14px 24px', marginTop: '24px',
                                                                    boxShadow: '0 -2px 8px rgba(16,39,70,0.06)',
                                                                }}>
                                                                    <button
                                                                        type="button"
                                                                        onClick={this.onSaveAsDraft}
                                                                        style={{
                                                                            background: '#fff', color: '#102746',
                                                                            border: '2px solid #102746', borderRadius: '6px',
                                                                            padding: '7px 20px', fontWeight: 600, fontSize: '13px', cursor: 'pointer',
                                                                        }}
                                                                    >
                                                                        Save as Draft
                                                                    </button>

                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                                        <button
                                                                            type="button"
                                                                            disabled={currentPageIdx === 0}
                                                                            onClick={() => this.goToPrevPage(sortedPageNumbers)}
                                                                            style={{
                                                                                background: currentPageIdx === 0 ? '#e3e8f0' : '#fff',
                                                                                color: currentPageIdx === 0 ? '#aaa' : '#102746',
                                                                                border: '2px solid ' + (currentPageIdx === 0 ? '#e3e8f0' : '#102746'),
                                                                                borderRadius: '6px', padding: '7px 20px',
                                                                                fontWeight: 600, fontSize: '13px',
                                                                                cursor: currentPageIdx === 0 ? 'not-allowed' : 'pointer',
                                                                            }}
                                                                        >
                                                                            &#8592; Previous
                                                                        </button>

                                                                        <span style={{
                                                                            background: '#102746', color: '#fff',
                                                                            borderRadius: '20px', padding: '5px 16px',
                                                                            fontSize: '13px', fontWeight: 700, letterSpacing: '0.3px',
                                                                        }}>
                                                                            Page {currentPageIdx + 1} of {sortedPageNumbers.length}
                                                                        </span>

                                                                        {!isLastPage ? (
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => this.goToNextPage(sortedPageNumbers)}
                                                                                style={{
                                                                                    background: '#102746', color: '#fff',
                                                                                    border: '2px solid #102746', borderRadius: '6px',
                                                                                    padding: '7px 20px', fontWeight: 600, fontSize: '13px', cursor: 'pointer',
                                                                                }}
                                                                            >
                                                                                Next &#8594;
                                                                            </button>
                                                                        ) : (
                                                                            <button
                                                                                type="button"
                                                                                onClick={this.submit}
                                                                                style={{
                                                                                    background: '#28a745', color: '#fff',
                                                                                    border: '2px solid #28a745', borderRadius: '6px',
                                                                                    padding: '7px 24px', fontWeight: 700, fontSize: '13px', cursor: 'pointer',
                                                                                }}
                                                                            >
                                                                                &#10003; Submit
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="survey-button-group">
                                                                    <button type="button" onClick={this.onSaveAsDraft} className="btn btn-secondary">Save as Draft</button>
                                                                    <button className="submit btn btn-secondary" style={{ background: '#102746' }} onClick={this.submit}>Submit</button>
                                                                </div>
                                                            );

                                                            return <>{renderedSections}{bottomBar}</>;
                                                        })()}
                                                    </div>
                                                ) : (
                                                    data && data.surveyQuestionAnswer && data.surveyQuestionAnswer.length === 0 ? (
                                                        <div className="row m-t-30">
                                                            <div className='col dnf-wrapper'>
                                                                <div className='dnf-content dnf-exclam'>
                                                                    <p className='dnf-exclam-mark'>!</p>
                                                                </div>
                                                                <div className='dnf-content dnf-text'>
                                                                    <p className='dnf'>Data Not Found</p>
                                                                    <p>Maybe go back and try a different keyword?</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div></div>
                                                    )
                                                )}

                                            </div>
                                        </>
                                            :
                                            <>

                                                <div className="starting-time">
                                                    <div className="col-8 mt-5">
                                                        <h2 className='survey-start-text'>Survey Starts In</h2>
                                                        <CountdownTimer targetDate={targetStartDate} />
                                                    </div>
                                                    <div className='d-flex mb-3'>
                                                        <div className='survey-part-info'>
                                                            <h4>Start Date:</h4>
                                                            <p>{this.formatTime(participantAttendees.startDateTime)} <br />
                                                                {this.formatDate(participantAttendees.startDateTime)}  </p>
                                                        </div>
                                                        <div className='survey-part-info'>
                                                            <h4>End Date: </h4>
                                                            <p>{this.formatTime(participantAttendees.endDateTime)} <br />
                                                                {this.formatDate(participantAttendees.endDateTime)}  </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {/* </fieldset> */}


                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                }
                {this.state.loading && !surveyExpired &&
                    <SurveyExpired></SurveyExpired>}
                <ToastContainer />
            </div>
        );
    }
}